import { apiClient } from "@/api/api-client";
import type { ChartOfAccount, JournalAccountPurpose, JournalAccountSetting } from "../../types/chart-of-accounts";

const journalAccountsService = {
	async listChartOfAccounts(refresh = false): Promise<ChartOfAccount[]> {
		const response = await apiClient.get<{ data: ChartOfAccount[] }>("/books/chart-of-accounts", {
			params: refresh ? { refresh: 1 } : undefined,
		});
		return response.data.data;
	},

	async getSettings(): Promise<JournalAccountSetting[]> {
		const response = await apiClient.get<{ data: JournalAccountSetting[] }>("/journal-account-settings");
		return response.data.data;
	},

	async updateSettings(settings: Array<{ purpose: JournalAccountPurpose; account_code: string }>): Promise<JournalAccountSetting[]> {
		const response = await apiClient.put<{ data: JournalAccountSetting[] }>("/journal-account-settings", { settings });
		return response.data.data;
	},

	async updateInvoiceOverrides(
		invoiceId: string,
		overrides: Partial<Record<JournalAccountPurpose, string | null>>,
	): Promise<{ invoice_id: string; overrides: Record<string, string> }> {
		const response = await apiClient.put<{ data: { invoice_id: string; overrides: Record<string, string> } }>(
			`/invoices/${invoiceId}/journal-account-overrides`,
			{ overrides },
		);
		return response.data.data;
	},

	async updateInvoiceRequestOverrides(
		requestId: string,
		overrides: Partial<Record<JournalAccountPurpose, string | null>>,
	): Promise<{ invoice_request_id: string; overrides: Record<string, string> }> {
		const response = await apiClient.put<{ data: { invoice_request_id: string; overrides: Record<string, string> } }>(
			`/invoice-requests/${requestId}/journal-account-overrides`,
			{ overrides },
		);
		return response.data.data;
	},

	async getCollectionItems(requestId: string): Promise<import("../../types/invoice").InvoiceJournalItems & { has_invoice?: boolean }> {
		const response = await apiClient.get<{ data: import("../../types/invoice").InvoiceJournalItems & { has_invoice?: boolean } }>(
			`/invoice-requests/${requestId}/collection-items`,
		);
		return response.data.data;
	},

	async postCollectionReceipt(requestId: string, status: "draft" | "posted" = "posted"): Promise<import("../../types/invoice").InvoiceJournalItems> {
		const response = await apiClient.post<{ data: import("../../types/invoice").InvoiceJournalItems }>(`/invoice-requests/${requestId}/collection-receipts`, {
			status,
		});
		return response.data.data;
	},
};

export default journalAccountsService;
